var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"logo"},[(_vm.currentLanguage === 'hr')?_c('logo-freelance-hr'):_vm._e(),_vm._v(" "),(_vm.currentLanguage === 'en')?_c('logo-cryptotask-org'):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }